var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatalogList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 105.5H94.25C100.463 105.5 105.5 100.463 105.5 94.25V86.75C105.5 80.537 100.463 75.5 94.25 75.5H38V105.5ZM38 68H94.25C100.463 68 105.5 62.963 105.5 56.75V49.25C105.5 43.0368 100.463 38 94.25 38H38V68ZM30.5 38V68H11.75C5.53677 68 0.5 62.963 0.5 56.75V49.25C0.5 43.0368 5.53677 38 11.75 38H30.5ZM38 30.5H94.25C100.463 30.5 105.5 25.4632 105.5 19.25V11.75C105.5 5.53677 100.463 0.5 94.25 0.5H38V30.5ZM30.5 0.5V30.5H11.75C5.53677 30.5 0.5 25.4632 0.5 19.25V11.75C0.5 5.53677 5.53677 0.5 11.75 0.5H30.5ZM30.5 75.5V105.5H11.75C5.53677 105.5 0.5 100.463 0.5 94.25V86.75C0.5 80.537 5.53677 75.5 11.75 75.5H30.5Z",
    fill: "#13559F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogList);
export default __webpack_public_path__ + "static/media/catalog-list.3240f730e8a910495ad3e8cc15d56e0a.svg";
export { ForwardRef as ReactComponent };